export default __webpack_public_path__ + "static/logo-nom-right-black-v4-bae193dbae412ca51e507b77b0647231.png";